import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { MODAL_TYPES } from '../../../common/constants'
import { hideModal } from '../../../store/modal'
import { ModalError } from './utils'

interface FormValidationErrorModalProps {
    isOpen: boolean
    formValidationErrorModal: {
        errorLabels: ModalError[]
    }
}

const FormValidationErrorModal = ({ isOpen, formValidationErrorModal }: FormValidationErrorModalProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { errorLabels = [] } = formValidationErrorModal || {}

    const handleClose = () => dispatch(hideModal({ modalType: MODAL_TYPES.FORM_VALIDATION_ERROR_MODAL }))

    return (
        <Modal isOpen={isOpen} centered toggle={handleClose} data-testid="form-validation-error-modal">
            <ModalHeader className="flex-column align-items-stretch p-3 bg-soft-danger">
                <div className="d-flex align-items-center w-100 text-danger">
                    <i className="mdi mdi-alert-circle-outline me-2 fs-4" />
                    {t('form.modal.error.title')}
                    <span onClick={handleClose} className="ms-auto px-2 cursor-pointer fs-5">
                        <i className="mdi mdi-close" />
                    </span>
                </div>
            </ModalHeader>
            <ModalBody>
                <ul className="list-unstyled lh-lg ms-4 mb-1">
                    {errorLabels.map(({ key, label }) => (
                        <li key={key}>{label}</li>
                    ))}
                </ul>
            </ModalBody>
        </Modal>
    )
}

export default FormValidationErrorModal
